<template>
  <div class="left-bar">
    <menuBut txt="题目" posy="-214" :is-active="menuState[0].isActive" :record-count="menuInfo[0].recordCount" @event-click="menuClick(0)"/>
    <menuBut txt="题解" posy="-146" :is-active="menuState[1].isActive" :record-count="menuInfo[1].recordCount" @event-click="menuClick(1)"/>
    <menuBut txt="记录" posy="-180" :is-active="menuState[2].isActive" :record-count="menuInfo[2].recordCount" @event-click="menuClick(2)"/>
  </div>
</template>

<script>
import menuBut from "@/components/element/menuBut";

export default {
  name: "leftBar",
  props:{
    menuInfo: Array
  },
  data(){
    return{
      menuState:[
        {isActive: false},
        {isActive: false},
        {isActive: false}
      ]
    }
  },
  methods:{
    menuClick: function (index){
      for(let i = 0, len = this.menuState.length; i < len; i ++){
        this.menuState[i].isActive = false;
      }
      this.menuState[index].isActive = true;
      this.$emit("event-menu-click", index)
    }
  },
  components:{
    menuBut
  }
}
</script>

<style scoped>
.left-bar{
  width: 50px;
  box-sizing: border-box;
  margin: 0px;
}
</style>
